const renewalDonationAmount = 15;

export default renewalDonationAmount;